import React, { useState, useEffect } from "react"
import { Tabs, Tab, Box, Grid } from "@mui/material"
import DataTable from "@/components/Tables/DataTable"
import { apiFetch } from "@/hooks/apiFetch"
import {
  formatDate,
  formatToDevanagariStyle,
  formatWeek,
} from "@/utilities/helper"
import SalesChart from "@/components/charts/SalesChart"
import MostSellingProductReport from "@/components/Reports/Product/MostSelling/MostSellingProductReport"
import ReportByTag from "@/components/Reports/Product/ByTag/ReportByTag"
import LowQuantityReport from "@/components/Reports/Product/LowQuantity/LowQuantityReport"
import ReportByCategory from "@/components/Reports/Product/ByCategory/ReportByCategory"

const ProductDashboard = () => {
  const [selectedTab, setSelectedTab] = useState("most_sale")

  return (
    <Box>
      <Tabs
        value={selectedTab}
        onChange={(event, newValue) => setSelectedTab(newValue)}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Most Sale" value="most_sale" />
        <Tab label="Low Quantity" value="low_quantity" />
        <Tab label="Sales By Tag" value="sales_by_tag" />
        <Tab label="Sales By Attribute" value="sales_by_category" />
      </Tabs>
      <Box sx={{ p: 3 }}>
        {selectedTab === "most_sale" && <MostSellingProductReport />}
        {selectedTab === "low_quantity" && <LowQuantityReport />}
        {selectedTab === "sales_by_tag" && <ReportByTag />}
        {selectedTab === "sales_by_category" && <ReportByCategory />}
      </Box>
    </Box>
  )
}

export default ProductDashboard
